import React, { useState } from 'react';
import { Button, Grid } from '@mui/material';
import { navigate } from 'gatsby';
import LogoutDialog from '@steamhub/components/dialogs/logout-dialog';
import { useAuth } from '@lib/auth';
import { LoginMethod } from '@store/slices/auth.slice';

const LogoutSection = ({ context }: { context: 'webapp' | 'steamhub' }) => {
  const [isLogoutDialogOpened, setIsLogoutDialogOpened] = useState(false);
  const { loginMethod, user } = useAuth();

  const handleLogoutClick = () => {
    setIsLogoutDialogOpened(true);
  };

  const redirectUrl = context === 'webapp' && user?.role === 'student' ? '/auth/webapp' : '/auth/login';

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <Button variant="contained" color="tertiary" onClick={handleLogoutClick} size={'large'} fullWidth>
            Logout
          </Button>
        </Grid>
      </Grid>

      <LogoutDialog
        open={isLogoutDialogOpened}
        dense
        onCancel={() => setIsLogoutDialogOpened(false)}
        onSubmit={() => {
          const queryString = loginMethod === LoginMethod.TEST_USER ? `testLogin=${user?.role}` : '';

          void navigate('/auth/logout', {
            state: {
              redirect: `${redirectUrl}?${queryString}`,
            },
          });
        }}
      />
    </>
  );
};

export default LogoutSection;
